module.exports = __webpack_public_path__ + "static/media/arrow-right-rsm.e33133ac.svg";